import { render, staticRenderFns } from "./order-tree-structure-comp.vue?vue&type=template&id=40ab1977&"
import script from "./order-tree-structure-comp.vue?vue&type=script&lang=js&"
export * from "./order-tree-structure-comp.vue?vue&type=script&lang=js&"
import style0 from "./order-tree-structure-comp.vue?vue&type=style&index=0&id=40ab1977&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports